export enum RouteKeys {
  List = '/product',
  Details = '/product/:id',
}
